import { Outlet } from "react-router-dom";
import Header from "../components/organisms/Header";
import Footer from "../components/organisms/Footer";
import Newsletter from "../components/organisms/Newsletter";

const MainLayout = () => {
  return (
    <div className="app-container main-template">
      <Header />
      <main className="main-template-content">
        <Outlet />
      </main>
      <Newsletter />
      <Footer />
    </div>
  );
};

export default MainLayout;
